export const ONGKIR_COURIERS = [
  { code: "anteraja", name: "AnterAja", type: "Express" },
  { code: "idx", name: "ID Express", type: "Express" },
  { code: "jne", name: "JNE Express", type: "Express" },
  { code: "jnt", name: "J&T Express", type: "Express" },
  { code: "jtcargo", name: "J&T Cargo", type: "Express" },
  { code: "lion", name: "Lion Parcel", type: "Express" },
  { code: "ncs", name: "NCS Courier", type: "Express" },
  { code: "ninja", name: "Ninja Xpress", type: "Express" },
  { code: "paxel", name: "Paxel", type: "Express" },
  { code: "posindonesia", name: "Pos Indonesia", type: "Express" },
  { code: "rpx", name: "RPX Logistics", type: "Express" },
  { code: "sap", name: "SAP Express", type: "Express" },
  { code: "sentral", name: "Sentral Cargo", type: "Express" },
  { code: "sicepat", name: "SiCepat", type: "Express" },
  { code: "spx", name: "SPX", type: "Express" },
  { code: "tiki", name: "Tiki", type: "Express" },
  { code: "wahana", name: "Wahana Express", type: "Express" }
];
